import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import SelectAsync from 'react-select/async';
import NumberFormat from 'react-number-format';

export default class FixedAmount extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/fixedamount/get", {
            id: this.getCurrentFormId()
        }).then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }



    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/fixedamount/save", {
            id: this.getCurrentFormId(),
            salaryYear: this.state.data.record.salaryYear,
            rightHousing: this.state.data.record.rightHousing,
            rightFood: this.state.data.record.rightFood,
            rightMarry: this.state.data.record.rightMarry,
            rightChildren: this.state.data.record.rightChildren



        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
 
    renderForm() {
        return <div className="container-fluid">
            <div className="nk-content-inner">
                <div className="nk-content-body">
                    <div className="components-preview wide-md mx-auto">
                        <div className="nk-block-head nk-block-head-lg wide-sm">
                            <div className="nk-block-head-content">
                                <div className="nk-block-head-sub">
                                    <NavLink className="back-to" to="/home/"><em className="icon ni ni-arrow-left"></em><span>داشبورد</span></NavLink>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <form method="post" onSubmit={e => this.save(e)} novalidate="novalidate">
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">
                                        <div className="card-aside-wrap">
                                            <div className="card-inner card-inner-lg">
                                                <div className="nk-block-head nk-block-head-lg">
                                                    <div className="nk-block-between">
                                                        <div className="nk-block-head-content">
                                                            <span>این تنظیمات مبالغ ثابت جهت قرارداد.</span>
                                                   
                                                        </div>

                                                        <div className="nk-block-head-content align-self-start d-lg-none">
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="nk-block">
                                                    <div class="card-inner-group">
                                       
                                                            <div class="card-inner border border-gray bg-lighter text-dark">



                                                                <div class="between-center flex-wrap g-3 border">
                                                                   


                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">حداقل مزدسال جاری</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" defaultValue={this.state.data.record.salaryYear} onChange={e => this.state.data.record.salaryYear=(this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">حق مسکن</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" defaultValue={this.state.data.record.rightHousing} onChange={e => this.state.data.record.rightHousing=(this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">حق خواروبار</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" defaultValue={this.state.data.record.rightFood} onChange={e => this.state.data.record.rightFood= (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">حق تاهل</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" defaultValue={this.state.data.record.rightMarry} onChange={e => this.state.data.record.rightMarry= (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-3">
                                                                        <div className="form-group">
                                                                            <label className="form-label text-soft">حق اولاد</label>
                                                                            <div className="form-control-wrap">

                                                                                <NumberFormat thousandSeparator={true} className="form-control" type="text" value={this.state.data.record.rightChildren} onChange={e => this.state.data.record.rightChildren= (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, '')))} />


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                   
                                                        <br />
                                                        <button className="btn btn-outline-success" type="submit" onClick={e => this.save(e)}>ثبت نهایی جداول مالیات</button>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg toggle-screen-lg" data-toggle-body="true" data-content="userAside" data-toggle-screen="lg" data-toggle-overlay="true" style={{ backgroundColor: "#16498a" }}>
                                                <div class="card-inner-group" data-simplebar="init">
                                                    <div class="simplebar-wrapper" style={{ margin: '0px' }} >
                                                        <div class="simplebar-height-auto-observer-wrapper">
                                                            <div class="simplebar-height-auto-observer"></div>
                                                        </div>
                                                        <div class="simplebar-mask">
                                                            <div class="simplebar-offset" style={{ left: '0px', bottom: '0px' }} >
                                                                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{ height: 'auto', overflow: 'hidden' }} >
                                                                    <div class="simplebar-content" style={{ padding: '0px' }} >
                                                                        <div class="card-inner">
                                                                            <h3 class="nk-block-title page-title text-white">تنظیمات</h3>
                                                                            <div class="nk-block-des text-soft text-white">
                                                                                <p className="text-white">در این قسمت مزایای شرکت خود را تعریف میکنید</p>
                                                                            </div>
                                                                        </div>

                                                                        <div class="card-inner p-0">
                                                                            <ul class="link-list-menu">
                                                                                <li>
                                                                                    <a class="active" className="text-white" href="/ConfigCompany"><em class="icon ni ni-user-fill-c text-white"></em><span>مزایا</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/ConfigTax" className="text-white"><em class="icon ni ni-lock-alt-fill text-white"></em><span>جدول مالیات</span></a>
                                                                                </li>
                                                                                <li style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)", backgroundColor: "#fff" }}>
                                                                                    <a href="/FixedAmount" style={{ boxShadow: "0 0 25px -12px rgba(31, 43, 58, 0.15)" }} ><em class="icon ni ni-shield-star-fill"></em><span>مبلغ ثابت جهت قرارداد</span></a>
                                                                                </li>
                                                                                <li>
                                                                                    <a href="/InsuranceTaxSettings" className="text-white"><em class="icon ni ni-activity-round-fill text-white"></em><span>سایر تنظیمات بیمه و مالیات</span></a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="simplebar-placeholder" style={{ width: 'auto', height: '376px' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ width: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                    <div class="simplebar-track simplebar-vertical" style={{ visibility: 'hidden' }} >
                                                        <div class="simplebar-scrollbar" style={{ height: '0px', display: 'none' }} >
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>



                    </div>
                </div>
            </div>





        </div >

    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}